<!--registerInfo 报名信息管理  -->
<template>
  <div class="registerInfo">
    <el-tabs v-model="actNum" v-if="activeMenu === 'registerExam'">
      <el-tab-pane label="科目展示" name="subject">
        <div v-if="activeMenu === 'registerExam'">
          <el-row class="tableHearInputBox" type="flex" justify="space-between">
            <el-col>
              <el-input
                v-model.trim="query.query"
                placeholder="请输入考试科目"
                style="width: 200px"
                @keyup.enter.native="tableLoad"
                @clear="
                  query.query = '';
                  query.pageNum = 1;
                  tableLoad();
                "
                clearable
                suffix-icon="el-icon-search"
              ></el-input>
              <Debounce>
                <el-button
                  style="margin:0px 10px"
                  size="small"
                  @click="tableLoad"
                  >查询
                </el-button>
              </Debounce>
   
              <el-select
                v-model="query.applicationYear"
                style="margin-right:10px"
                @change="changeYear"
                filterable
                placeholder="请选择"
              >
                <!-- <el-option label="全部年份" value=""></el-option> -->
                <el-option
                  v-for="item in applicationFilterYearList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select
                style="margin-right:10px"
                v-model="query.kspc"
                @change="frechLoad"
                filterable
                placeholder="请选择"
              >
                <el-option label="全部批次" value=""></el-option>
                <el-option
                  v-for="item in kspcList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select
                style="margin-left: 10px;width: 160px"
                v-model="query.hasLock"
                @change="tableLoad"
                filterable
                placeholder="请选择"
              >
                <el-option label="全部科目状态" value=""></el-option>
                <el-option label="科目状态（正常）" :value="'0'"></el-option>
                <el-option label="科目状态（锁定）" :value="'1'"></el-option>
              </el-select>
            </el-col>
            <el-button
              type="primary"
              @click="getdownLoad"
              v-if="$roleFilter('apply::download')"
              >下载模板</el-button
            >
            <el-button
              type="primary"
              @click="exportApplyInfo"
              v-if="$roleFilter('apply::export')"
              >导出报名信息</el-button
            >
            <!-- 上传文件 -->
            <el-upload
              action="/api/apply/import/apply"
              :on-success="handleUploadSuccess"
              :show-file-list="false"
              accept=".xls,.xlsx"
              :before-upload="beforeUpload"
              v-if="$roleFilter('apply::import')"
            >
              <el-button
                ghost
                type="primary"
                size="large"
                style="margin-left:15px"
                >导入报名信息
              </el-button>
            </el-upload>
          </el-row>
          <el-table
            :data="tableList"
            tooltip-effect="dark"
            border
            ref="elTable"
            style="width: 100%;max-height: 650px;"
            :header-cell-style="$store.getters.getTableHeadStyle"
            v-loading="tableIsLoad"
            element-loading-text="加载中"
            :height="$store.getters.getTableHeight"
          >
            <el-table-column
              prop="subjectName"
              label="考试科目"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="applicationYear"
              width="200px"
              :formatter="formatApplicationYear"
              label="考试年份"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="examinationForm_dictText"
              label="考试形式"
              align="center"
            >
              <!-- <template slot-scope="scope">
                {{ scope.row.examinationForm === 1 ? "线下考试" : "线上考试" }}
              </template> -->
            </el-table-column>
            <el-table-column prop="kspc" label="考试批次" align="center">
              <template slot-scope="scope">
                {{
                  scope.row.kspc === 1
                    ? "春季"
                    : scope.row.kspc === 2
                    ? "夏季"
                    : scope.row.kspc === 3
                    ? "秋季"
                    : scope.row.kspc === 4
                    ? "冬季"
                    : ""
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="fbTime"
              label="报名开始时间"
              align="center"
              :min-width="120"
            >
            </el-table-column>
            <el-table-column
              prop="deadline"
              label="报名截止时间"
              align="center"
              :min-width="120"
            >
              <template slot-scope="scope">
                {{ scope.row.deadline | getTimeByTimestamp }}
              </template>
            </el-table-column>
            <el-table-column
              prop="willnum"
              label="报名人数"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="needNerifyNum"
              label="待审核人数"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="unpassNum"
              label="未通过人数"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="payNum"
              label="已缴费人数"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="noPayNum"
              label="未缴费人数"
              align="center"
            ></el-table-column>
            <el-table-column label="报名详情" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="operatInfo(scope.row)"
                  >报名详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <Pagination
            :total="query.total"
            :page.sync="query.pageNum"
            :limit.sync="query.pageSize"
            class="pagination-content"
            @pagination="tableLoad"
          />
        </div>
      </el-tab-pane>
      <el-tab-pane label="考生展示" name="examinee">
        <examineeList />
      </el-tab-pane>
    </el-tabs>
    <router-view v-else />
  </div>
</template>

<script>
import { exportFile } from "@/uitls/globalFun.js";

import examineeList from "./registerInfo/examineeList.vue";
export default {
  components: { examineeList },
  data() {
    return {
      applicationFilterYearList: [], //年份过滤框
      tableList: [],
      // yearList: [],
      // lotList: [],
      kspcList: [
        { value: "1", label: "春季" },
        { value: "2", label: "夏季" },
        { value: "3", label: "秋季" },
        { value: "4", label: "冬季" },
      ],
      tableIsLoad: false,
      actNum: "subject",
      query: {
        query: "",
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
        applicationYear: "", //考试年份
        kspc: "",
        hasLock: '0',
      },
      exportTicketLoading: false,
    };
  },
  async mounted() {
    await this.getApplicationFilterYearSelect();
    // await this.getSelectList();
  },
  computed: {
    activeMenu() {
      return this.$route.name;
    },
    uploadUrl() {
      return this.$store.getters["skb/getUploadUrl"];
    },
  },
  methods: {
    // async getSelectList() {
    //   this.$axios.get("/apply/yearLine").then((res) => {
    //     let data = res.data.data;
    //     this.yearList = data;
    //     if (Array.isArray(data) && data[0].parentId) {
    //       this.query.applicationYear = data[0].parentId;
    //       // this.lotList = this.yearList.filter((item) => {
    //         // return item.parentId == this.query.applicationYear;
    //       // })[0].children;
    //     }
    //     this.tableLoad();
    //   });
    // },
    changeYear(val) {
      // console.log(555, val, this.yearList);
      // this.query.kspc = "";
      // if (val) {
      //   this.lotList = this.yearList.filter((item) => {
      //     return item.parentId == val;
      //   })[0].children;
      // } else {
      //   this.lotList = [];
      // }
      this.frechLoad();
    },
    frechLoad() {
      this.query.pageNum = 1;
      this.tableLoad();
    },
    //导出报名信息
    exportApplyInfo() {
      // window.location.href = `/api/apply/export?year=${this.query.applicationYear}`
      let query = {
        query: this.query.query,

        applicationYear: this.query.applicationYear? Number(this.query.applicationYear):"",
        kspc: this.query.kspc,
        hasLock: this.query.hasLock + "",
      };
      this.exportTicketLoading = true;
      this.$axios
        .post("/apply/exportStu", query, { responseType: "blob" })
        .then((res) => {
          exportFile(res);
          this.exportTicketLoading = false;
        });
    },
    //格式化年份
    formatApplicationYear: function(row, column) {
      return row.applicationYear + "年";
    },
    //获取考试年份过滤下拉
    async getApplicationFilterYearSelect() {
      await this.$axios.get("/examInformation/selectFilterData").then((rs) => {
        let appYears = rs.data.data;
        this.applicationFilterYearList = appYears;
        this.query.applicationYear = appYears[0].label;
        this.tableLoad();
      });
    },
    tableLoad() {
      
      this.query.applicationYear= this.query.applicationYear? Number(this.query.applicationYear):""
      this.$axios.post("/apply/list", this.query).then((res) => {
        let { list, total } = res.data.data;
        this.tableList = list;
        this.query.total = total;
        this.tableIsLoad = false;
      });
    },
    operatInfo(row) {
      console.log(
        888,
        row.deadline,
        new Date().getTime(),
        new Date().getTime() > row.deadline
      );
      this.$router.push({
        path: "/examManag/registerExam/registerInfo",
        query: {
          id: row.id,
          name: row.subjectName,
          pay: new Date().getTime() > row.deadline,
        },
      });
    },
    // 下载模板
    getdownLoad() {
      window.location.href = "/api/apply/download/apply";
    },
    // 文件上传成功的处理函数
    handleUploadSuccess(res) {
      console.log(res);
      if (res.code == "10000") {
        this.$message({ type: "success", message: res.msg, duration: 1000 });
        this.tableLoad();
      } else {
        this.$message({ type: "error", message: res.msg, duration: 1000 });
      }
    },
    // 限制文件大小 50m
    beforeUpload(file) {
      console.log(file);
      if (file.size / 1024 / 1024 > 50) {
        console.log("上传文件过大", file.size);
        this.$message({
          message: "上传文件大小不能超过 50MB!",
          type: "error",
        });
        return false; //必须返回false
      }
    },
  },
};
</script>
